
/*
Defines the custom element <ravel-lcd>
*/

import { RavelLCD } from './src/RavelLCD.js';

customElements.define('ravel-lcd', RavelLCD);
